import angular from 'angular'
import mainCtrl from './main_ctrl'
import searchWizardCtrl from './search_wizard'
import fileUploadCtrl from './file_upload_ctrl'
import {
  importDashboardCtrl,
  importUserInfoCtrl,
  importUserLicensesCtrl,
  selectDomainCtrl,
  uploadCsvCtrl,
  wizardCtrl,
  confirmImportCtrl
} from './import_wizard'

export default angular
  .module('adminPanel.controllers', [])
  .controller('MainCtrl', mainCtrl)
  .controller('SearchWizardCtrl', searchWizardCtrl)
  .controller('FileUploadCtrl', fileUploadCtrl)
  .controller('ImportDashboardCtrl', importDashboardCtrl)
  .controller('ImportUserInfoCtrl', importUserInfoCtrl)
  .controller('ImportUserLicensesCtrl', importUserLicensesCtrl)
  .controller('SelectDomainCtrl', selectDomainCtrl)
  .controller('UploadCSVCtrl', uploadCsvCtrl)
  .controller('WizardCtrl', wizardCtrl)
  .controller('ConfirmImportCtrl', confirmImportCtrl)
